import { render, staticRenderFns } from "./top10.vue?vue&type=template&id=75b80492&"
import script from "./top10.vue?vue&type=script&lang=ts&"
export * from "./top10.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports